import React, { useEffect, useState } from "react";
import {
  CircularProgressbar,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const CircularLoader = ({questionsNum, questionsType}) => {
  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    if (!questionsNum) return;

    const MAX_PERCENT = 97;

    const baseTimePerQuestion = 1000;
    const multiplier = questionsType === "multiple_choice" ? 2 : 1;
    const totalDuration = questionsNum * baseTimePerQuestion * multiplier;

    const updateInterval = 100;
    const totalSteps = totalDuration / updateInterval;
    const stepIncrement = MAX_PERCENT / totalSteps;

    const interval = setInterval(() => {
      setPercentage((prev) => {
        const next = prev + stepIncrement;
        if (next >= MAX_PERCENT) {
          clearInterval(interval);
          return MAX_PERCENT;
        }
        return next;
      });
    }, updateInterval);

    return () => clearInterval(interval);
  }, [questionsNum, questionsType]);

  return (
    <div className="circular-loadgin-wrapper">
      <div>
        <CircularProgressbar
          value={Math.round(percentage)}
          text={`${Math.round(percentage)}%`}
          styles={buildStyles({
            textSize: "20px",
            lineHeight: "28px",
            pathColor: "#E63C2E",
            textColor: "#191919",
            trailColor: "#E6E6E6",
          })}
        />
      </div>
      <p>Generating quiz questions...</p>
    </div>
  );
};

export default CircularLoader;
